import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Podmienky() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="aurora-wrap" aria-hidden="true">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
      </div>
      <div className="legal-inner container">
        <Link to="/" className="legal-back">← Späť na hlavnú stránku</Link>
        <h1 className="legal-title">Obchodné podmienky</h1>
        <p className="legal-updated">Posledná aktualizácia: 1. januára 2026</p>

        <div className="legal-content">
          <h2>1. Prevádzkovateľ</h2>
          <p>
            Tieto obchodné podmienky sa vzťahujú na služby poskytované Kamilom Frajtkom pod
            obchodným menom Boostio. Kontakt: <a href="mailto:info@boostio.sk">info@boostio.sk</a>
          </p>

          <h2>2. Predmet zmluvy</h2>
          <p>
            Predmetom zmluvy je poskytovanie digitálnych služieb vrátane tvorby webstránok,
            e-shopov, správy marketingu, sociálnych sietí, automatizácií a správy webov.
            Konkrétny rozsah je vymedzený v zákazkovom liste alebo e-mailovej korešpondencii.
          </p>

          <h2>3. Cenová ponuka a platba</h2>
          <p>
            Ceny sú stanovené individuálne alebo podľa cenníka na webstránke. Faktúra je splatná
            do 14 dní od vystavenia. Pri projektoch nad 500€ je štandardná záloha 50% pred
            zahájením prác.
          </p>

          <h2>4. Dodacie podmienky</h2>
          <p>
            Štandardná dodacia lehota pre weby je 7 pracovných dní od uhradenia zálohy a
            poskytnutia všetkých podkladov. Pri komplexnejších projektoch sa dodacia lehota
            dohodne individuálne.
          </p>

          <h2>5. Autorské práva</h2>
          <p>
            Po uhradení celkovej ceny zákazník získava plné práva na používanie dodaného diela.
            Boostio si vyhradzuje právo použiť projekt ako referenciu, pokiaľ zákazník
            nevyjadrí nesúhlas písomnou formou.
          </p>

          <h2>6. Reklamácie a záruky</h2>
          <p>
            Zákazník má právo bezplatnej opravy chýb, ktoré vznikli na strane Boostio, počas
            30 dní od odovzdania projektu. Záruky sa nevzťahujú na zmeny vykonané zákazníkom.
          </p>

          <h2>7. Zodpovednosť</h2>
          <p>
            Boostio nezodpovedá za výpadky serverov tretích strán, zmeny algoritmov
            vyhľadávačov ani za výsledky marketingových kampaní, na ktoré vplývajú faktory
            mimo kontroly Boostio.
          </p>

          <h2>8. Ukončenie spolupráce</h2>
          <p>
            Ktorákoľvek zo strán môže ukončiť spoluprácu s výpovednou lehotou 30 dní.
            Pri predplatených mesačných službách bude zostatok vrátený pomerne.
          </p>

          <h2>9. Rozhodné právo</h2>
          <p>
            Tieto obchodné podmienky sa riadia právnym poriadkom Slovenskej republiky.
            Prípadné spory budú riešené príslušným súdom v SR.
          </p>

          <h2>10. Zmeny podmienok</h2>
          <p>
            Boostio si vyhradzuje právo tieto podmienky aktualizovať. O podstatných zmenách
            budú aktívni zákazníci informovaní e-mailom.
          </p>
        </div>
      </div>
    </div>
  );
}
